module.exports = __webpack_public_path__ + "assets/img/day.6293815e.svg";